import { useReducer } from 'react'
import { Box, Paper, TextField, Button, Typography } from '@mui/material'
import { Grid, FormSection, UniversalModal } from '../UniversalComponents'
import { useAuth } from '../../context/AuthenticationContext'
import loginLogo from '../../assets/osmosis/Logos/loginLogo.png'

const LoginPage = () => {
    const defaultState = {
        formData: {
            username: '',
            password: '',
        },
        formValidation: {
            usernameValidation: true,
            passwordValidation: true,
        },
        openResetPassword: false,
    }
    const reducer = (oldState, newState) => ({ ...oldState, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)
    const { formData, openResetPassword } = state
    const { username, password } = formData
    const handleChange = (e: any) => {
        const { name, value } = e.target
        setState({
            formData: { ...formData, [name]: value },
        })
    }

    const { signIn } = useAuth()

    return (
        <Box
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    signIn({ username, password })
                }
            }}
            sx={{
                position: 'relative',
                zIndex: 1,
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                // Scrim over the background video so the card stays legible.
                background:
                    'linear-gradient(180deg, rgba(34,31,31,0.55) 0%, rgba(34,31,31,0.85) 100%)',
            }}
        >
            <Paper id="login" elevation={0}>
                <Box sx={{ textAlign: 'center', mb: 1.5 }}>
                    <img
                        src={loginLogo}
                        alt="Osmosis"
                        style={{ width: 210, maxWidth: '70%' }}
                    />
                </Box>

                <Typography
                    variant="overline"
                    sx={{
                        display: 'block',
                        textAlign: 'center',
                        color: 'primary.main',
                        mb: 0.5,
                    }}
                >
                    Fleet Intelligence Platform
                </Typography>
                <Typography
                    variant="h5"
                    sx={{ textAlign: 'center', fontWeight: 700, mb: 3 }}
                >
                    Sign in
                </Typography>

                <TextField
                    label="Username"
                    placeholder="Enter username"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                    name="username"
                    value={username}
                    onChange={handleChange}
                />
                <TextField
                    margin="normal"
                    name="password"
                    label="Password"
                    placeholder="Enter password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    required
                    value={password}
                    onChange={handleChange}
                />

                <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    fullWidth
                    onClick={() => signIn({ username, password })}
                    sx={{ mt: 2, py: 1.2, fontWeight: 700 }}
                >
                    Sign in
                </Button>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mt: 1.5,
                    }}
                >
                    <Button
                        onClick={() =>
                            setState({ openResetPassword: !openResetPassword })
                        }
                        color="primary"
                        variant="text"
                        size="small"
                    >
                        Reset password
                    </Button>

                    <Button
                        component="a"
                        href="https://osmosis-os.com/deactivate-account"
                        target="_blank"
                        rel="noopener noreferrer"
                        color="inherit"
                        variant="text"
                        size="small"
                        sx={{ color: 'text.secondary' }}
                    >
                        Delete account
                    </Button>
                </Box>
            </Paper>
            <UniversalModal
                title={'Reset Password'}
                open={openResetPassword}
                onClose={() => {
                    setState({ openResetPassword: !openResetPassword })
                }}
                fullScreen={false}
                wrapperStyle={{
                    margin: 'auto',
                    width: '80%',
                    marginTop: 5,
                }}
            >
                <FormSection
                    title="Please enter your registered email address to recover your account password."
                    titleAlignment="center"
                >
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <TextField
                                margin="normal"
                                name="Registered Email Address"
                                label="Registered Email Address"
                                placeholder="Enter Your Email Address"
                                variant="outlined"
                                fullWidth
                                required
                                onChange={handleChange}
                            />

                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                sx={{ my: 1 }}
                                fullWidth
                                onClick={() => ({})}
                            >
                                Submit Email Address
                            </Button>
                        </Grid>
                    </Grid>
                </FormSection>
            </UniversalModal>
        </Box>
    )
}

export default LoginPage
